<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyWord"
              :placeholder="$l('purchase_package_search')||'包装采购单号/订单编号....'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                $emit('openEditPage', {
                  pageType: 'add',
                  params: {},
                })
              "
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l("INDEX.btn_add") || "新增" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('form_lable_purchasePackageNo')||'包装采购单号'">
              <el-input
                v-model.trim="form.purchasePackageNo"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderNo') || '订单编号'"
            >
              <el-input v-model.trim="form.orderNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.purchase_form_label_scmCode') || '大货供应商'"
            >
              <dict-select
                :placeholder="
                  $l('INDEX.tips_purchase_form_label_scmCode') ||
                    '请选择大货供应商'
                "
                size="small"
                clearable
                filterable
                v-model="form.scmCode"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_buyerName')||'采购人员'">
              <dict-select
                clearable
                v-model="form.buyerCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="form.buyerName"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_contactName')||'供应商联系人'">
              <el-input v-model.trim="form.contactName" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="
                $l('form_label_contact_mobile') || '联系人手机'
              "
            >
              <el-input
                v-model.trim="form.contactMobile"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item :label="$l('form_label_receiveContact')||'收货联系人'">
              <el-input
                v-model.trim="form.receiveContact"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="
                $l('form_label_receiveContactMobile') ||
                  '收货联系人手机'
              "
            >
              <el-input
                v-model.trim="form.receiveContactMobile"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-col :span="12">
              <el-form-item :label="$l('form_label_purchaseDate')||'采购日期'">
                <el-date-picker
                  v-model="form.beginPurchaseDate"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="beginPurchaseDatePicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="-">
                <el-date-picker
                  v-model="form.endPurchaseDate"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="endPurchaseDatePicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <el-date-picker
                  v-model="form.beginCreateDate"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="beginCreateStartPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="-">
                <el-date-picker
                  v-model="form.endCreateDate"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="endCreateStartPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.table_label_modification_time') || '修改时间'"
              >
                <el-date-picker
                  v-model="form.beginModifyDate"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="modifyTimeStartPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="-">
                <el-date-picker
                  v-model="form.endModifyDate"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="modifyTimeEndPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>

          <el-col :span="12">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.table_label_reviewer_by_time') || '审核时间'"
              >
                <el-date-picker
                  v-model="form.beginReviewTime"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="reviewTimeStartPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="-">
                <el-date-picker
                  v-model="form.endReviewTime"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="reviewTimeEndPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.table_label_receiverAddress')||'收货地址'">
              <el-input
                v-model.trim="form.receiveAddress"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_purchaseStatus')||'采购单状态'">
              <dict-select
                multiple
                clearable
                v-model="form.purchaseStatusList"
                filterable
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                url="/sys/common/dict/system"
                :body="{ dictType: 'purchaseStatus' }"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l("INDEX.btn_cancel_query") || "取消查询"
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l("INDEX.btn_reset_filter") || "重置条件"
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l("INDEX.btn_data_retrieval") || "数据检索"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyWord: "",
  purchaseStatusList: ["N", "D", "Y"],
}
export default {
  data() {
    return {
      form: { ...initForm },
      advqueryDialogVisible: false,
      //
      beginPurchaseDatePicker: this.datePurchaseDateEnd(),
      endPurchaseDatePicker: this.datePurchaseDateStart(),
      //创建时间
      beginCreateStartPicker: this.dateCreateEnd(),
      endCreateStartPicker: this.dateCreateStart(),
      //修改时间
      modifyTimeStartPicker: this.dateModityEnd(),
      modifyTimeEndPicker: this.dateModityStart(),
      //审核时间
      reviewTimeStartPicker: this.dateReviewTimeEnd(),
      reviewTimeEndPicker: this.dateReviewTimeStart(),
    }
  },
  activated() {
    this.query()
  },
  methods: {
    // 高级查询
    advquery() {
      this.form.keyWord = ""
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    query() {
      this.$emit("query", this.form)
    },
    datePurchaseDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endReviewTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endReviewTime).getTime() < time.getTime()
          }
        },
      }
    },
    datePurchaseDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginPurchaseDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginPurchaseDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    dateReviewTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endPurchaseDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endPurchaseDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateReviewTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginReviewTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginReviewTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    dateModityEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endModifyDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endModifyDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateModityStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginModifyDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginModifyDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    dateCreateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endCreateDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endCreateDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateCreateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginCreateDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginCreateDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
